export default __webpack_public_path__ + "static/media/Aqeel.f30a30a3.png";